import React from 'react'
import ReactDOM from 'react-dom'
import _ from 'lodash'

export default class QmlComponent extends React.Component {
    static cardName = `REG/CardPatientAddress.qml`;
    
    constructor() {
        super()
        this._ismounted = false
        this.state = {
            qml : null
        }
    }

    componentDidMount() {
        this._ismounted = true
        //console.log("!!!<<<<<<CDM>>>>>>>!!! ", this.cardName)
        

        //console.log('about to this.loadQML')
// Soure code from QML file starts here 
setTimeout( () => { 
this.loadQML(String.raw`
import Semantic.Html 1.0
import QmlWeb 1.0
Segment{
    className: "defaultBackground"

    property var updateFromServer : false

    // Province ---------------------------------------------------------------------------------
    RequestMemory{
        id: provinceMem
        url: '/apis/core/province/?limit=99999'

        onFetched:{
            homeAddressRest.cboProvince_.items = provinceMem.getItems()
            presentAddressRest.cboProvince_.items = provinceMem.getItems()
            relativeAddressRest.cboProvince_.items = provinceMem.getItems()
        }
    }
    // District ---------------------------------------------------------------------------------
    RequestMemory{
        id: districtMem
        url: '/apis/core/district/?limit=99999'

        // We disable render all district because there is performance issue when rendering > 1000 items on screen
        // onFetched:{
        //     homeAddressRest.cboDistrict_.items = districtMem.getItems()
        //     presentAddressRest.cboDistrict_.items = districtMem.getItems()
        //     relativeAddressRest.cboDistrict_.items = districtMem.getItems()
        // }
    }

    // City ---------------------------------------------------------------------------------
    RequestMemory{
        id: cityMem
        url: '/apis/core/city/?limit=99999'

        // We disable render all city because there is performance issue when rendering > 1000 items on screen
        // onFetched:{
        //     homeAddressRest.cboCity_.items = cityMem.getItems()
        //     presentAddressRest.cboCity_.items = cityMem.getItems()
        //     relativeAddressRest.cboCity_.items = cityMem.getItems()
        // }
    }

    property RestModel restModel: RestModel{
        hierarchy:{
            return{
                home_address: homeAddressRest.restModel,
                present_address: presentAddressRest.restModel,
                relative_address: relativeAddressRest.restModel
            }
        }
    }

    /**
    * For setting the patient address programmatically.
    * These address data may obtained from SmartCard or National Database
    **/
    function setPatientHomeAddress(house_no, moo, soi, road, tambol, amphoe, province) {
        homeAddressRest.setAddress(house_no, moo, soi, road, tambol, amphoe, province)
    }

    function setExtraPatientHomeAddress(house_type, village) {
        homeAddressRest.setExtraAddress(house_type, village)
    }

    Form{
        SubAddress{
            id: homeAddressRest
            headName: "ที่อยู่ตามทะเบียนบ้าน / Address according to house registration"
            show_copy_home_address_checkbox: false
            show_copy_present_address_checkbox: false
            show_contact: false
        }
        Dom{ tagName:"br" }
        SubAddress{
            id: presentAddressRest
            headName: "ที่อยู่ปัจจุบัน / Current address"
            show_copy_present_address_checkbox: false
            onCopyHomeAddress:{
                presentAddressRest.copy()
                presentAddressRest.restModel.no        = homeAddressRest.restModel.no;
                presentAddressRest.restModel.name      = homeAddressRest.restModel.name;
                presentAddressRest.restModel.town      = homeAddressRest.restModel.town;
                presentAddressRest.restModel.street    = homeAddressRest.restModel.street;
                presentAddressRest.restModel.road      = homeAddressRest.restModel.road;
                presentAddressRest.restModel.edit_user = homeAddressRest.restModel.edit_user;
                presentAddressRest.cboType_.value      = homeAddressRest.cboType_.getValue();
                presentAddressRest.cboProvince_.value  = homeAddressRest.cboProvince_.getValue();
            }
            onProvinceChange:{
                presentAddressRest.cboDistrict_.value  = homeAddressRest.cboDistrict_.getValue();
            }
            onDistrictChange:{
                presentAddressRest.cboCity_.value      = homeAddressRest.cboCity_.getValue();
            }
        }
        Dom{ tagName:"br" }
        SubAddress{
            id: relativeAddressRest
            headName: "ที่อยู่ผู้ติดต่อ / Contact address"
            showRelativeFields: true
            onCopyHomeAddress:{
                if (source == "home copied"){
                    relativeAddressRest.copy()
                    relativeAddressRest.restModel.no        = homeAddressRest.restModel.no;
                    relativeAddressRest.restModel.name      = homeAddressRest.restModel.name;
                    relativeAddressRest.restModel.town      = homeAddressRest.restModel.town;
                    relativeAddressRest.restModel.street    = homeAddressRest.restModel.street;
                    relativeAddressRest.restModel.road      = homeAddressRest.restModel.road;
                    relativeAddressRest.restModel.edit_user = homeAddressRest.restModel.edit_user;
                    relativeAddressRest.cboType_.value      = homeAddressRest.cboType_.getValue();
                    relativeAddressRest.cboProvince_.value  = homeAddressRest.cboProvince_.getValue();
                }
                else if (source == "present copied"){
                    relativeAddressRest.copy()
                    relativeAddressRest.restModel.no        = presentAddressRest.restModel.no;
                    relativeAddressRest.restModel.name      = presentAddressRest.restModel.name;
                    relativeAddressRest.restModel.town      = presentAddressRest.restModel.town;
                    relativeAddressRest.restModel.street    = presentAddressRest.restModel.street;
                    relativeAddressRest.restModel.road      = presentAddressRest.restModel.road;
                    relativeAddressRest.restModel.edit_user = presentAddressRest.restModel.edit_user;
                    relativeAddressRest.cboType_.value      = presentAddressRest.cboType_.getValue();
                    relativeAddressRest.cboProvince_.value  = presentAddressRest.cboProvince_.getValue();
                }
            }
            onProvinceChange:{
                if (source == "home copied"){
                    relativeAddressRest.cboDistrict_.value  = homeAddressRest.cboDistrict_.getValue();
                }
                if (source == "present copied"){
                    relativeAddressRest.cboDistrict_.value  = presentAddressRest.cboDistrict_.getValue();
                }
            }
            onDistrictChange:{
                if (source == "home copied"){
                    relativeAddressRest.cboCity_.value      = homeAddressRest.cboCity_.getValue();
                }
                if (source == "present copied"){
                    relativeAddressRest.cboCity_.value      = presentAddressRest.cboCity_.getValue();
                }
            }
        }
        
    }
    function clear(){
        homeAddressRest.clear()
        presentAddressRest.clear()
        relativeAddressRest.clear()
    }
}

        `)
}, 0)

    }

    componentWillUnmount() {
        this._ismounted = false
        //console.log(" ***** componentWillUnmount ", this.cardName)
        document.onkeypress = null;
        document.onkeyup = null;

        // this.engine.stop()
        if(this.qml){
            this.qml.destroy()
            this.removeChildProperties(this.qml)
        }
        
        // this.qml = null
        // this.engine = null
        if(this.props.onUnmount){
            this.props.onUnmount()
         }
        // window.QmlWeb.engine.dom = null
        // window.QmlWeb.engine.domTarget = null
        // window.QmlWeb.engine.rootObject = null
        // window.QmlWeb.engine.completedSignals = []
        // window.QmlWeb.engine = {}
        //console.log(" ***** componentWillUnmount Finish ", this.cardName)
    }

    loadQML = (src, parentComponent = null, file = undefined) => {
        this.loadQMLTree(window.QmlWeb.parseQML(src, file), parentComponent, file);
        
        // let component = this.loadQMLTree(window.QmlWeb.parseQML(src, file), parentComponent, file);
        // this.qml = this.engine.rootObject
        // return component
    }

    loadQMLTree = (tree, parentComponent = null, file = undefined) => {

        // Part 1
        let QMLComponent; 
        let component;

        setTimeout( () => { 

            if (!this._ismounted){
                //console.log(" Shutdown Part 1", this.cardName)
                return;
            }
            this.engine = window.QmlWeb.engine;
        
            if (!this.engine) {
                this.engine = new window.QmlWeb.QMLEngine(ReactDOM.findDOMNode(this));
                // window.addEventListener("resize", () => this.engine.updateGeometry());
            } else {
                this.engine.cleanEngine(ReactDOM.findDOMNode(this))
            }

            this.engine.$basePathA = document.createElement('a')
            this.engine.$basePathA.href = this.extractBasePath(`/static/qml/REG/CardPatientAddress.qml`)
            this.engine.$basePath = this.engine.$basePathA.href
            //console.log(" CDM this.engine.$basePathA.href: ", this.engine.$basePathA.href)

            window.QmlWeb.engine = this.engine;

            // Create and initialize objects
            QMLComponent = window.QmlWeb.getConstructor("QtQml", "2.0", "Component");
            component = new QMLComponent({
                object: tree,
                parent: parentComponent
            });
            //console.log("Part 1", this.cardName)
        },0)

        setTimeout(() => {
            if (!this._ismounted){
                //console.log(" Shutdown Part 2", this.cardName)
                return;
            }
            
            this.engine.loadImports(tree.$imports, undefined, component.importContextId);
            component.$basePath = this.engine.$basePath;
            component.$imports = tree.$imports; // for later use
            component.$file = file; // just for debugging
            //console.log("Part 2", this.cardName)
        }, 0);
    

        // Part 3,4,5
        setTimeout(() => {
            if (!this._ismounted){
                //console.log(" Shutdown Part 3", this.cardName)
                return;
            }
            this.engine.rootObject = component.$createObject(parentComponent);
            
            if (this.engine.rootObject.dom) {
                this.engine.domTarget.appendChild(this.engine.rootObject.dom);
            }
     
            this.qml = this.engine.rootObject
            this.setUpSignals()
            this.setUpProperties()
            //console.log("3. setUpSignals(), setUpProperties() Done", this.cardName)
 
            this.engine.$initializePropertyBindings();
            this.engine.start();

            this.engine.updateGeometry();
            this.qml = this.engine.rootObject

            this.setState({qml: this.qml})
            //console.log("4. finish loadQMLTree", this.cardName)

            
            this.engine.firstCallCompleted = false;
            this.engine.callCompletedSignals();
            this.engine.firstCallCompleted = true;
            //console.log("5. CallCompletedSignal", this.cardName)

            if (this.props.completedQMLLoad) {
                //console.log("Callback completedQMLLoad !!")
                setTimeout( () => {
                    this.props.completedQMLLoad()
                })
            }
        }, 0);
    }
    
    deCapitalizeFirstLetter(string) {
        return string.charAt(0).toLowerCase() + string.slice(1);
    }

    hasSignalName(signalName) {
        return (
            typeof this.qml[signalName] === 'function' 
            && typeof this.qml[signalName].connect === 'function'
        )
    }

    setUpSignals() {
        _.forOwn(this.props, (value, key) => {
            let signalName = this.deCapitalizeFirstLetter(key.replace('on', ''))
            let startsWithOn = key.startsWith('on')
            let typeFunction = typeof value === 'function'
            if (!startsWithOn || !typeFunction) {
                return
            }
            if (!this.hasSignalName(signalName)) {
                console.warn('Cannot find a signal name: ' + signalName)
                return
            }
            this.qml[signalName].disconnect()
            this.qml[signalName].connect(this.qml, value)
        })
    }

    setUpProperties() {
        _.forOwn(this.props, (value, key) => {
            let signalName = this.deCapitalizeFirstLetter(key.replace('on', ''))
            let propertyExists = typeof this.qml.$properties[key] !== 'undefined'
            if (this.hasSignalName(signalName)) {
                return
            }
            if (!propertyExists) {
                const createProperty = window.QmlWeb.createProperty;
                createProperty("variant", this.qml, key, value);
                //console.warn('Cannot find a property name: ' + key)
                // return
            }
            this.qml[key] = value
        })
    }

    extractBasePath(file) {
        const basePath = file.split(/[/\\\\]/)
        basePath[basePath.length - 1] = ''
        return basePath.join('/')
    }

    extractFileName(file) {
        return file.split(/[/\\\\]/).pop()
    }

    removeChildProperties(child) {
        const signals = this.engine.completedSignals
        if (signals) {
            signals.splice(signals.indexOf(child.Component.completed), 1)
        }
        if(child.children) {
            for (let i = 0; i < child.children.length; i++) {
                this.removeChildProperties(child.children[i])
            }
        }
        child.$signals = null
    }

    render() {
        if (this.state.qml) {
            this.setUpSignals()
            this.setUpProperties()
        }
        return React.createElement('div')
    }
}